module.exports = __webpack_public_path__ + "static/media/MainChef.788f60d4.sol";


//////////////////
// WEBPACK FOOTER
// ./contracts/levels/MainChef.sol
// module id = 1851
// module chunks = 0